import React from "react"

type Props = {
  slug: string
  network: string
  image?: string
  title?: string
  children: React.ReactNode
}

export const SocialShareLink: React.FC<Props> = ({
  slug,
  network,
  image,
  title,
  children,
}) => {
  let url = ""
  switch (network) {
    case "facebook": {
      url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(slug)}`
      break
    }
    case "twitter": {
      url = `https://twitter.com/intent/tweet?url=${encodeURI(slug)}`
      break
    }
    case "pinterest": {
      url = `https://pinterest.com/pin/create/button/?url=${encodeURI(
        slug
      )}&media=${encodeURI(image ?? "")}&description=${title}`
      break
    }
    case "whatsapp": {
      url = `https://api.whatsapp.com/send?phone=&text=${encodeURI(slug)}`
      break
    }

    default: {
      url = slug
    }
  }
  return (
    <a
      href={url}
      title={`Share to ${network}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}
